import { Box, Grid, Paper } from "@mui/material";
import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MapWaterHomeComponent from "../components/map/MapWaterHome.component";
import HomeAreaChartComponent from "shared-components/src/components/charts/homeAreaChart.component";
import WeatherForecastComponent from "shared-components/src/components/weatherForecast/WeatherForecastNew.component";
import { getDataFromModelRequest } from "../store/actions/realtimeDataFromModel.actions";

const HomePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const weatherForecast = useSelector((state) => state.weatherForecast).data;
  const waterSystems = useSelector((state) => state.waterSystems);
  const waterDataFromModel = useSelector(
    (state) => state.waterDataFromModel?.data,
  );

  const position = waterSystems?.data[0]?.attributes?.polygons[0]?.position[0];
  const prioritySystem = waterSystems?.data?.find(
    (item) => item.attributes.id_thing === "acquaountcantonierareservoir",
  );
  const id_thing = prioritySystem?.attributes?.id_thing;
  const modelData = waterDataFromModel?.modelOutputs;
  const volumeData =
    modelData?.data?.filter((item) => item.measure === "storage") || [];
  const outflowData = modelData?.data?.filter(
    (item) =>
      item.measure === "combined outflow (Irrigation Demand + Urban Demand)",
  );

  useEffect(() => {
    dispatch(getDataFromModelRequest(id_thing));
  }, [dispatch, id_thing]);

  return (
    <Fragment>
      <Grid
        container
        spacing={2}
        sx={{ marginTop: "5px", marginBottom: "20px" }}
      >
        {/* Weather and Overview */}
        <Grid item xs={12} md={4}>
          {weatherForecast && (
            <Paper
              variant="outlined"
              sx={{ height: "100%", paddingX: "20px", paddingBottom: "20px" }}
            >
              <h3>{t("home.weather-forecast")}</h3>
              <div style={{ minHeight: "320px" }}>
                <WeatherForecastComponent position={position} />
              </div>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper
            variant="outlined"
            sx={{ height: "100%", paddingX: "20px", paddingBottom: "20px" }}
          >
            <h3>{t("home.oveview")}</h3>
            <MapWaterHomeComponent />
          </Paper>
        </Grid>
        {/* Forecast and Flow projection */}
        <Grid item xs={12} md={4}>
          <Paper
            variant="outlined"
            sx={{ height: "100%", paddingX: "20px", paddingBottom: "20px" }}
          >
            <h3>{t("home.months-water-forecast")}</h3>
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              borderRadius="10px"
            >
              <HomeAreaChartComponent
                volumeData={volumeData}
                unitOfMeasure={"Volume (m³ × 10⁶)"}
              />
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper
            variant="outlined"
            sx={{
              height: "100%",
              paddingX: "20px",
              paddingBottom: "20px",
            }}
          >
            <h3>{t("home.mounths-flow-projection")}</h3>
            <HomeAreaChartComponent
              volumeData={outflowData}
              unitOfMeasure={"Flow (m^3/s)"}
            />
          </Paper>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default HomePage;
